const titleTransitionDurationMs = 175;
const summary = "_35ssjwqpck";
const container = "_35scw242u8";
const mobileTopContainer = "_35smfob8vd";
const mobileBottomContainer = "_35sm1niuu3b";

// NB: DOM displays title before status to improve screen-reader experience as
// status is needs context from title before being relevant.
const status = "_35ss8wu3ax";
const titleContainer = "_35st1blpaa1";
const title = "_35stmozx21";
const stats = "_35ss1cgj7cj";
const didAnswer = "_35sdjfvfrc";
const chevron = "_35sc1m6d7ue";

export { chevron, container, didAnswer, mobileBottomContainer, mobileTopContainer, stats, status, summary, title, titleContainer, titleTransitionDurationMs };
import "./molecule.summary.style.linaria.module.css";
//# sourceMappingURL=molecule.summary.style.js.map
